import type { Due, RegisterRow } from './api';

export interface RecallLine {
  key: string;
  /** Same wording as the API's RECALL_TITLES and the overdue list. */
  title: string;
  due: Due;
}

/**
 * The recalls of one register row, in the API's order (RL-996
 * `recallItems`): the checks the automatic reminder job watches. The
 * register already carries each check's due state, computed by the same rule.
 */
export function recallsOf(row: RegisterRow): RecallLine[] {
  if (row.condition === 'diabetes' && 'hba1c' in row)
    return [
      { key: 'hba1c', title: 'HbA1c', due: row.hba1c },
      { key: 'eye', title: 'Eye screening', due: row.eye },
      { key: 'foot', title: 'Foot check', due: row.foot },
      { key: 'uacr', title: 'Kidney test (urine ACR)', due: row.uacr },
    ];
  if (row.condition === 'hypertension' && 'review' in row)
    return [
      { key: 'bp_review', title: 'Blood pressure review', due: row.review },
    ];
  if (row.condition === 'asthma' && 'review' in row)
    return [
      {
        key: 'asthma_review',
        title: 'Asthma review and action plan',
        due: row.review,
      },
    ];
  return [];
}

/**
 * Whether the reminder job sends this patient's recalls: it skips patients
 * whose saved plan is hidden from the app (no plan = reminders still go).
 */
export function remindersOn(plan: { showInApp: boolean } | null): boolean {
  return !plan || plan.showInApp;
}
